<template>
  <div class="thinktankBox">
    <div class="thinktankItem">
      <div class="word noselect">
        <img :src="$oss + itemData.cover" alt="" style="width: 100%;height: 100%;"/>
        <vue-office-docx
          v-if="false"
          :src="url"
          @rendered="onRendered"
          :style="docxStyle"
        />
      </div>
      <div class="mask">
        <div v-if="isBuy" class="btn" @click="$emit('yulan')">查看</div>
        <div v-if="isBuy" class="btn" @click="$emit('xiazai')">下载</div>

        <div
          v-if="!isBuy"
          class="btn"
          :class="{ twoLine: !isBuy }"
          @click="$emit('yulan')"
        >
          <div class="el-icon-view"></div>
          <div>预览</div>
        </div>
        <div
          v-if="!isBuy"
          class="btn"
          :class="{ twoLine: !isBuy }"
          @click="$emit('xiazai')"
        >
          <div class="el-icon-download"></div>
          <div>下载</div>
        </div>
      </div>
    </div>
    <div class="thinktanFooter">
      <div class="title single-line">{{ itemData.subject }}</div>
      <div class="bottom" v-if="!isBuy">
        <div class="price">¥{{ itemData.price | priceFormat }}</div>
        <div class="time">{{ itemData.updatedAt | timeFormat }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import VueOfficeDocx from "@vue-office/docx";
import "@vue-office/docx/lib/index.css";
export default {
  components: { VueOfficeDocx },
  props: {
    itemData: {
      type: Object,
      default: () => ({
        subject: "",
        url: "",
      }),
    },
    isBuy: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // url: "http://static.shanhuxueyuan.com/test6.docx",
      docxStyle: {}, // 存储动态缩放样式
    };
  },

  created() {},
  computed: {
    url() {
      if (this.isBuy) {
        return this.$oss + this.itemData.url;
      } else {
        return this.$oss + this.itemData.previewUrl;
      }
    },
  },
  methods: {
    onRendered() {
      this.$nextTick(() => {
        // 获取实际内容元素（根据组件内部结构调整选择器）
        const contentEl = this.$el.querySelector(".docx-wrapper > .docx");
        if (!contentEl) return;
        // 获取元素原始宽度（单位：px）
        const originalWidthPx = parseFloat(window.getComputedStyle(contentEl).width);
        console.log(originalWidthPx);
        // 计算缩放比例（目标宽度 197px）
        const targetWidthPx = 197;
        const zoom = targetWidthPx / originalWidthPx;

        // 直接设置 zoom
        this.docxStyle = {
          zoom: zoom, // 直接传递 zoom 值
        };
      });
    },
  },
};
</script>

<style scoped lang="scss">
.thinktankBox {
  border-radius: 6px;
  border: 1px solid #eeeeee;
  overflow: hidden;

  .thinktanFooter {
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    background: linear-gradient(180deg, #f2f3f566 0%, rgba(255, 255, 255, 0.3) 100%);
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #262626;
      width: calc(225px - 28px);
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      .price {
        font-size: 14px;
        color: #f45858;
      }
      .time {
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
.thinktankItem {
  width: 225px;
  height: 248px;

  /* 自动布局 */
  display: flex;
  background: #ffffff;
  box-sizing: border-box;

  position: relative;
  overflow: hidden;
  flex-direction: column;
  .title {
    height: 50px;
    background: linear-gradient(180deg, #e8f3ff 0%, rgba(232, 243, 255, 0.3) 86%);
    width: 100%;
    padding-left: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    .icon {
      width: 18px;
      height: 18px;
      border-radius: 2px;
      background: #0062ff26;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
  .word {
    width: 197px;
    height: 220px;
    margin: 0 auto;
    margin-top: 16px;
    overflow: hidden; // 隐藏溢出内容
    &::v-deep .docx-wrapper {
      padding: 0 !important;
      .docx {
        padding-top: 0px !important;
        // zoom: 0.248;
      }
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    position: absolute;
    display: none;
    align-items: center;
    justify-content: center;
    gap: 14px;
    z-index: 2;
    // img {
    //   width: 60px;
    //   height: 60px;
    //   cursor: pointer;
    // }
    .btn {
      width: 60px;
      height: 60px;
      cursor: pointer;
      background: rgba($color: #000000, $alpha: 0.4);
      color: #ffffff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      &:hover {
        background: rgba($color: #ffffff, $alpha: 0.8);
        color: #0062ff;
      }
    }
    .twoLine {
      flex-direction: column;
      gap: 3px;
    }
  }
  &:hover {
    .mask {
      display: flex;
    }
  }
}
</style>
